import { render, staticRenderFns } from "./tournamentGroups.vue?vue&type=template&id=57281103&scoped=true&"
import script from "./tournamentGroups.vue?vue&type=script&lang=js&"
export * from "./tournamentGroups.vue?vue&type=script&lang=js&"
import style0 from "./tournamentGroups.vue?vue&type=style&index=0&id=57281103&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57281103",
  null
  
)

export default component.exports